export default "{\n    \"title\": \"Assign to Staff Member\",\n    \"subtitle\": \"Create and assign work orders to staff members\"\n}\n"